export default "__VITE_ASSET__BxxqnbZ2__"